"use client";

import { useMemo } from "react";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import Img1Tr from "~/assets/images/announcement/section5-img1-tr.png?url";
import Img1 from "~/assets/images/announcement/section5-img1.png?url";
import Img2Tr from "~/assets/images/announcement/section5-img2-tr.png?url";
import Img2 from "~/assets/images/announcement/section5-img2.png?url";
import Img3Tr from "~/assets/images/announcement/section5-img3-tr.png?url";
import Img3 from "~/assets/images/announcement/section5-img3.png?url";
import Img4Tr from "~/assets/images/announcement/section5-img4-tr.png?url";
import Img4 from "~/assets/images/announcement/section5-img4.png?url";
import Img5Tr from "~/assets/images/announcement/section5-img5-tr.png?url";
import Img5 from "~/assets/images/announcement/section5-img5.png?url";
import Img6Tr from "~/assets/images/announcement/section5-img6-tr.png?url";
import Img6 from "~/assets/images/announcement/section5-img6.png?url";
import Img7Tr from "~/assets/images/announcement/section5-img7-tr.png?url";
import Img7 from "~/assets/images/announcement/section5-img7.png?url";
import Img8Tr from "~/assets/images/announcement/section5-img8-tr.png?url";
import Img8 from "~/assets/images/announcement/section5-img8.png?url";
import CollapsibleHeroCollection from "~/common/components/CollapsibleHeroCollection";

import styles from "./AnnouncementsSection5.module.scss";

export default function AnnouncementsSection5({ locale }) {
  const { t } = useTranslation();

  const section2Data = useMemo(
    () => [
      {
        id: "bulk-campaign",
        iconAlt: "Bulk Campaign Icon",
        iconBgClass: "blue",
        titleKey: /** @i18n */ "announcements.section5.bulkCampaign.title",
        descriptionKey: /** @i18n */ "announcements.section5.bulkCampaign.description",
        image: locale == "tr" ? Img1Tr : Img1,
      },
      {
        id: "member-welcome",
        iconAlt: "Member Welcome Icon",
        iconBgClass: "pink",
        titleKey: /** @i18n */ "announcements.section5.memberWelcome.title",
        descriptionKey: /** @i18n */ "announcements.section5.memberWelcome.description",
        image: locale == "tr" ? Img2Tr : Img2,
      },
      {
        id: "first-purchase",
        iconAlt: "First Purchase Icon",
        iconBgClass: "blue",
        titleKey: /** @i18n */ "announcements.section5.firstPurchase.title",
        descriptionKey: /** @i18n */ "announcements.section5.firstPurchase.description",
        image: locale == "tr" ? Img3Tr : Img3,
      },
      {
        id: "shipping-notification",
        iconAlt: "Shipping Icon",
        iconBgClass: "pink",
        titleKey: /** @i18n */ "announcements.section5.shippingNotification.title",
        descriptionKey: /** @i18n */ "announcements.section5.shippingNotification.description",
        image: locale == "tr" ? Img4Tr : Img4,
      },
      {
        id: "cart-recovery",
        iconAlt: "Cart Recovery Icon",
        iconBgClass: "blue",
        titleKey: /** @i18n */ "announcements.section5.cartRecovery.title",
        descriptionKey: /** @i18n */ "announcements.section5.cartRecovery.description",
        image: locale == "tr" ? Img5Tr : Img5,
      },
      {
        id: "order-tracking",
        iconAlt: "Order Tracking Icon",
        iconBgClass: "pink",
        titleKey: /** @i18n */ "announcements.section5.orderTracking.title",
        descriptionKey: /** @i18n */ "announcements.section5.orderTracking.description",
        image: locale == "tr" ? Img6Tr : Img6,
      },
      {
        id: "back-in-stock",
        iconAlt: "Back in Stock Icon",
        iconBgClass: "blue",
        titleKey: /** @i18n */ "announcements.section5.backInStock.title",
        descriptionKey: /** @i18n */ "announcements.section5.backInStock.description",
        image: locale == "tr" ? Img7Tr : Img7,
      },
      {
        id: "birthday-message",
        iconAlt: "Birthday Icon",
        iconBgClass: "pink",
        titleKey: /** @i18n */ "announcements.section5.birthdayMessage.title",
        descriptionKey: /** @i18n */ "announcements.section5.birthdayMessage.description",
        image: locale == "tr" ? Img8Tr : Img8,
      },
    ],
    [locale]
  );

  return (
    <div className={clsx("card", styles.card)}>
      <h3 className={styles.title}>{t("announcements.section5.title")}</h3>
      <div className={styles.content}>
        <CollapsibleHeroCollection items={section2Data} t={t} />
      </div>
    </div>
  );
}
